import IconArrowLeft, {
	IconArrowLeftProps as _IconArrowLeftProps,
} from './IconArrowLeft';

export { IconArrowLeft };
export type IconArrowLeftProps = _IconArrowLeftProps;
